import { render, staticRenderFns } from "./MandateRevokeConfirmationModal.vue?vue&type=template&id=49856d4c&"
import script from "./MandateRevokeConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./MandateRevokeConfirmationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports